import { FileSharer } from "@byteowls/capacitor-filesharer";
import { isDefined } from "@clipboard-health/util-ts";
import { useToast } from "@src/appV2/lib";
import { useMutation } from "@tanstack/react-query";
import { domToPng } from "modern-screenshot";

interface ShareResult {
  shared: boolean;
  error?: string;
}

export function useShareHolidayGift() {
  const { showErrorToast } = useToast();

  return useMutation({
    mutationFn: async (): Promise<ShareResult> => {
      try {
        const node = document.querySelector("#holiday-gift-share-screen");

        if (!isDefined(node)) {
          return { shared: false };
        }

        const dataUrl = await domToPng(node, {
          width: window.innerWidth,
          height: 0.65 * window.innerHeight,
          drawImageInterval: 500,
        });

        // Extract base64 data from data URL (remove "data:image/png;base64," prefix)
        const base64Data = dataUrl.split(",")[1];

        await FileSharer.share({
          filename: "Clipboard - Free Gift.png",
          base64Data,
          contentType: "image/png",
        });

        return { shared: true };
      } catch (maybeError) {
        const error = maybeError as Error;

        showErrorToast("We couldn't share your achievement. Please try again.");
        return {
          shared: false,
          error: error.message,
        };
      }
    },
  });
}
